import { render, staticRenderFns } from "./CoEventTicketCreateEdit.vue?vue&type=template&id=71ad8030&"
import script from "./CoEventTicketCreateEdit.vue?vue&type=script&lang=ts&"
export * from "./CoEventTicketCreateEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports